/* Speed Junkies - Past Winners gallery. Scoped to .sj-w roots. */
(function () {
  'use strict';

  /* Guard against the asset being included by more than one section on the page. */
  if (window.__sjWinnersLoaded) return;
  window.__sjWinnersLoaded = true;

  var ROOT_SEL = '[data-sj-winners]';
  var API_PATH = '/apps/api/winners';

  function esc(v) {
    if (v === null || v === undefined) return '';
    return String(v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function ytId(url) {
    if (!url) return '';
    var m = String(url).match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
    return m ? m[1] : '';
  }

  function vimeoId(url) {
    if (!url) return '';
    var m = String(url).match(/vimeo\.com\/(?:video\/|channels\/[A-Za-z0-9_-]+\/|groups\/[A-Za-z0-9_-]+\/videos\/)?(\d{6,})/);
    return m ? m[1] : '';
  }

  function fmtDate(iso, locale) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return String(iso);
    try {
      return d.toLocaleDateString(locale || document.documentElement.lang || 'en-US', { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' });
    } catch (e) {
      return d.toISOString().slice(0, 10);
    }
  }

  function yearOf(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    return isNaN(d.getTime()) ? '' : String(d.getUTCFullYear());
  }

  /* ---------- normalise a record coming from the Speed Junkies Manager API ---------- */
  function fromApi(rec) {
    var name = [rec.first_name, rec.last_initial ? String(rec.last_initial).replace(/\.$/, '') + '.' : ''].filter(Boolean).join(' ').trim();
    var media = [];
    (rec.media_urls || []).forEach(function (u) {
      if (u) media.push({ type: 'image', src: String(u), alt: name ? name + ' with the ' + (rec.prize_name || 'prize') : 'Speed Junkies winner photo' });
    });
    var v = rec.video_url || rec.youtube || '';
    if (v) {
      var y = ytId(v), vm = vimeoId(v);
      if (y) media.push({ type: 'video', kind: 'youtube', src: y, poster: media.length ? media[0].src : '' });
      else if (vm) media.push({ type: 'video', kind: 'vimeo', src: vm, poster: media.length ? media[0].src : '' });
      else media.push({ type: 'video', kind: 'file', src: String(v), poster: media.length ? media[0].src : '' });
    }
    var social = rec.instagram || rec.facebook || rec.twitter || '';
    if (social && social.charAt(0) === '@') social = 'https://www.instagram.com/' + social.slice(1);
    return {
      id: 'api-' + rec.id,
      name: name,
      location: rec.location || '',
      prize: rec.prize_name || '',
      category: '',
      drawnIso: rec.win_date || '',
      drawnText: fmtDate(rec.win_date),
      announcedText: '',
      story: '',
      prizeDesc: rec.prize_desc || '',
      prizeSpecs: '',
      social: social,
      socialLabel: rec.instagram ? 'Instagram' : (rec.facebook ? 'Facebook' : (rec.twitter ? 'Profile' : '')),
      rules: '',
      socialShow: true,
      featured: false,
      year: yearOf(rec.win_date),
      media: media
    };
  }

  var ICON_PIN = '<svg viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 1116 0z"/><circle cx="12" cy="10" r="3"/></svg>';
  var ICON_PLAY = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>';
  var ICON_TROPHY = '<svg viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M8 4h8v4a4 4 0 01-8 0V4zM6 5H4a3 3 0 003 3M18 5h2a3 3 0 01-3 3M12 12v4M9 20h6M10 16h4v4h-4z"/></svg>';

  /* Client-side card markup. Mirrors snippets/sj-winner-card.liquid. */
  function cardHtml(w, i, strings) {
    var h = [];
    h.push('<li class="sj-w-card" data-sj-card data-index="' + i + '" data-year="' + esc(w.year) + '" data-category="' + esc(String(w.category || '').toLowerCase()) + '">');
    h.push('<div class="sj-w-card__media">');
    var first = null, j;
    for (j = 0; j < w.media.length; j++) { if (w.media[j].type === 'image') { first = w.media[j]; break; } }
    if (!first) { for (j = 0; j < w.media.length; j++) { if (w.media[j].poster) { first = { src: w.media[j].poster, alt: w.name }; break; } } }
    if (first) {
      h.push('<img src="' + esc(first.src) + '" alt="' + esc(first.alt || (w.name + ' - ' + w.prize)) + '" loading="lazy" decoding="async" width="800" height="600">');
    } else {
      h.push('<div class="sj-w-card__noimg" aria-hidden="true">' + ICON_TROPHY + '</div>');
    }
    if (w.featured) h.push('<span class="sj-w-card__feat">' + esc(strings.featured) + '</span>');
    if (hasVideo(w)) h.push('<span class="sj-w-card__vid">' + ICON_PLAY + esc(strings.video) + '</span>');
    if (w.drawnText) h.push('<span class="sj-w-card__date">' + esc(strings.drawn) + ' ' + esc(w.drawnText) + '</span>');
    h.push('</div><span class="sj-w-card__stripe" aria-hidden="true"></span>');
    h.push('<div class="sj-w-card__body">');
    h.push('<h3 class="sj-w-card__name">' + esc(w.name) + '</h3>');
    if (w.location) h.push('<span class="sj-w-card__loc">' + ICON_PIN + esc(w.location) + '</span>');
    if (w.prize) h.push('<span class="sj-w-card__prize">' + esc(w.prize) + '</span>');
    h.push('<div class="sj-w-card__cta"><button type="button" class="sj-w__btn sj-w__btn--ghost" data-sj-open="' + i + '">' + esc(strings.view) + '<span class="sj-w__sr"> - ' + esc(w.name) + '</span></button></div>');
    h.push('</div></li>');
    return h.join('');
  }

  function hasVideo(w) {
    for (var i = 0; i < w.media.length; i++) if (w.media[i].type === 'video') return true;
    return false;
  }

  function imageCount(w) {
    var n = 0;
    for (var i = 0; i < w.media.length; i++) if (w.media[i].type === 'image') n++;
    return n;
  }

  /* ============================ Gallery controller ============================ */
  function initGallery(root) {
    if (root.dataset.sjReady === '1') return;
    root.dataset.sjReady = '1';

    var strings = {};
    try { strings = JSON.parse(root.getAttribute('data-sj-strings') || '{}'); } catch (e) { strings = {}; }
    strings.drawn = strings.drawn || 'Drawn';
    strings.video = strings.video || 'Video';
    strings.featured = strings.featured || 'Featured';
    strings.view = strings.view || 'View Winner Story';

    var gridEl = root.querySelector('[data-sj-grid]');
    var skelEl = root.querySelector('[data-sj-skeleton]');
    var emptyEl = root.querySelector('[data-sj-empty]');
    var errorEl = root.querySelector('[data-sj-error]');
    var noneEl = root.querySelector('[data-sj-nofilter]');
    var retryEl = root.querySelector('[data-sj-retry]');
    var countEl = root.querySelector('[data-sj-count]');
    var filtersEl = root.querySelector('[data-sj-filters]');
    var yearSel = root.querySelector('[data-sj-filter-year]');
    var catSel = root.querySelector('[data-sj-filter-category]');

    var winners = [];
    var serverRendered = gridEl ? gridEl.children.length > 0 : false;
    var seeded = root.querySelector('[data-sj-data]');
    if (seeded) {
      try { winners = JSON.parse(seeded.textContent || '[]'); } catch (e) { winners = []; }
    }
    winners.forEach(function (w) { w.media = w.media || []; });

    var modal = new WinnerModal(root, strings);

    function show(el, on) { if (el) el.hidden = !on; }

    function paint() {
      show(skelEl, false);
      show(errorEl, false);
      if (!winners.length) { show(gridEl, false); show(filtersEl, false); show(emptyEl, true); return; }
      show(emptyEl, false);
      if (!serverRendered) {
        gridEl.innerHTML = winners.map(function (w, i) { return cardHtml(w, i, strings); }).join('');
      }
      show(gridEl, true);
      buildFilters();
      modal.setData(winners);
      applyFilters();
    }

    function buildFilters() {
      if (!filtersEl) return;
      var minRecords = parseInt(root.getAttribute('data-sj-filter-min') || '4', 10);
      var years = [], cats = [];
      winners.forEach(function (w) {
        if (w.year && years.indexOf(w.year) === -1) years.push(w.year);
        var c = String(w.category || '').trim();
        if (c && cats.indexOf(c) === -1) cats.push(c);
      });
      years.sort().reverse();
      cats.sort();
      var showYear = yearSel && years.length > 1;
      var showCat = catSel && cats.length > 1;
      if (winners.length < minRecords || (!showYear && !showCat)) { show(filtersEl, false); return; }
      if (yearSel) {
        yearSel.parentElement.hidden = !showYear;
        if (showYear) {
          yearSel.innerHTML = '<option value="">' + esc(strings.allYears || 'All years') + '</option>' + years.map(function (y) { return '<option value="' + esc(y) + '">' + esc(y) + '</option>'; }).join('');
        }
      }
      if (catSel) {
        catSel.parentElement.hidden = !showCat;
        if (showCat) {
          catSel.innerHTML = '<option value="">' + esc(strings.allCategories || 'All prize types') + '</option>' + cats.map(function (c) { return '<option value="' + esc(c.toLowerCase()) + '">' + esc(c) + '</option>'; }).join('');
        }
      }
      show(filtersEl, true);
    }

    function applyFilters() {
      var y = yearSel && !yearSel.parentElement.hidden ? yearSel.value : '';
      var c = catSel && !catSel.parentElement.hidden ? catSel.value : '';
      var visible = 0;
      var cards = gridEl.querySelectorAll('[data-sj-card]');
      Array.prototype.forEach.call(cards, function (card) {
        var ok = (!y || card.getAttribute('data-year') === y) && (!c || card.getAttribute('data-category') === c);
        card.hidden = !ok;
        if (ok) visible++;
      });
      modal.setFilter(y, c);
      show(noneEl, visible === 0 && winners.length > 0);
      if (countEl) {
        countEl.textContent = visible === winners.length
          ? String(winners.length) + ' ' + (winners.length === 1 ? (strings.winner || 'winner') : (strings.winners || 'winners'))
          : String(visible) + ' ' + (strings.of || 'of') + ' ' + String(winners.length);
      }
    }

    if (yearSel) yearSel.addEventListener('change', applyFilters);
    if (catSel) catSel.addEventListener('change', applyFilters);

    gridEl.addEventListener('click', function (ev) {
      var btn = ev.target.closest('[data-sj-open]');
      if (!btn) return;
      modal.open(parseInt(btn.getAttribute('data-sj-open'), 10), btn);
    });

    /* Featured section can hand off to this gallery modal. */
    root.addEventListener('sj:open-winner', function (ev) {
      var key = ev.detail && ev.detail.id;
      var idx = -1;
      winners.forEach(function (w, i) { if (String(w.id) === String(key)) idx = i; });
      if (idx > -1) modal.open(idx, ev.detail && ev.detail.trigger, ev.detail && ev.detail.mediaIndex);
    });

    /* ---------- live source (Speed Junkies Manager) ---------- */
    function loadFromApi(isRetry) {
      show(emptyEl, false); show(errorEl, false); show(noneEl, false); show(gridEl, false); show(filtersEl, false);
      show(skelEl, true);
      var limit = root.getAttribute('data-sj-api-limit') || '24';
      var ctrl = ('AbortController' in window) ? new AbortController() : null;
      var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 12000);
      fetch(API_PATH + '?page=1&limit=' + encodeURIComponent(limit), { headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) {
          if (!r.ok) throw new Error('winners endpoint responded ' + r.status);
          return r.json();
        })
        .then(function (data) {
          clearTimeout(timer);
          if (!data || data.success !== true || !Array.isArray(data.winners)) throw new Error('winners endpoint returned an unexpected payload');
          winners = data.winners.filter(function (r) { return r && r.approved !== false; }).map(fromApi);
          serverRendered = false;
          paint();
        })
        .catch(function (err) {
          clearTimeout(timer);
          if (window.console && console.warn) {
            console.warn('[Speed Junkies] Past Winners: could not load live winner records.', { source: API_PATH, reason: err && err.message ? err.message : err, retry: !!isRetry });
          }
          show(skelEl, false);
          show(gridEl, false);
          show(errorEl, true);
        });
    }

    if (retryEl) retryEl.addEventListener('click', function () { loadFromApi(true); });

    if (winners.length) {
      paint();
    } else if (root.getAttribute('data-sj-api-fallback') === 'true') {
      loadFromApi(false);
    } else {
      show(skelEl, false);
      show(emptyEl, true);
    }
  }

  /* ============================== Modal ============================== */
  function WinnerModal(root, strings) {
    var self = this;
    this.root = root;
    this.strings = strings;
    this.data = [];
    this.filter = { year: '', cat: '' };
    this.index = -1;
    this.mediaIndex = 0;
    this.opener = null;

    var dlg = root.querySelector('[data-sj-modal]');
    this.dlg = dlg;
    if (!dlg) return;

    this.frame = dlg.querySelector('[data-sj-modal-frame]');
    this.thumbs = dlg.querySelector('[data-sj-modal-thumbs]');
    this.nameEl = dlg.querySelector('[data-sj-modal-name]');
    this.prizeEl = dlg.querySelector('[data-sj-modal-prize]');
    this.dlEl = dlg.querySelector('[data-sj-modal-dl]');
    this.storyEl = dlg.querySelector('[data-sj-modal-story]');
    this.linksEl = dlg.querySelector('[data-sj-modal-links]');
    this.counterEl = dlg.querySelector('[data-sj-modal-counter]');
    this.prevBtn = dlg.querySelector('[data-sj-modal-prev]');
    this.nextBtn = dlg.querySelector('[data-sj-modal-next]');
    this.closeBtn = dlg.querySelector('[data-sj-modal-close]');

    if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self.step(-1); });
    if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.step(1); });
    if (this.closeBtn) this.closeBtn.addEventListener('click', function () { self.close(); });

    dlg.addEventListener('cancel', function (ev) { ev.preventDefault(); self.close(); });
    dlg.addEventListener('click', function (ev) { if (ev.target === dlg) self.close(); });
    dlg.addEventListener('keydown', function (ev) {
      if (ev.key === 'ArrowRight' && !ev.target.matches('button[data-sj-thumb]')) { self.step(1); }
      else if (ev.key === 'ArrowLeft' && !ev.target.matches('button[data-sj-thumb]')) { self.step(-1); }
    });
    if (this.thumbs) {
      this.thumbs.addEventListener('click', function (ev) {
        var b = ev.target.closest('[data-sj-thumb]');
        if (b) self.showMedia(parseInt(b.getAttribute('data-sj-thumb'), 10), true);
      });
    }
    if (this.frame) {
      this.frame.addEventListener('click', function (ev) {
        var p = ev.target.closest('[data-sj-playbtn]');
        if (p) self.play();
      });
    }
  }

  WinnerModal.prototype.setData = function (d) { this.data = d || []; };
  WinnerModal.prototype.setFilter = function (y, c) { this.filter = { year: y || '', cat: c || '' }; if (this.index > -1) this.updateNav(); };

  WinnerModal.prototype.visibleIndexes = function () {
    var f = this.filter, out = [];
    this.data.forEach(function (w, i) {
      var ok = (!f.year || String(w.year) === f.year) && (!f.cat || String(w.category || '').toLowerCase() === f.cat);
      if (ok) out.push(i);
    });
    return out;
  };

  WinnerModal.prototype.open = function (i, opener, mediaIdx) {
    if (!this.dlg || !this.data[i]) return;
    this.opener = opener || null;
    this.index = i;
    this.render();
    var jump = parseInt(mediaIdx, 10);
    if (!isNaN(jump) && jump > 0) this.showMedia(jump, false);
    if (typeof this.dlg.showModal === 'function') { if (!this.dlg.open) this.dlg.showModal(); }
    else { this.dlg.setAttribute('open', ''); }
    document.body.classList.add('sj-w-modal-open');
    var focusTarget = this.closeBtn || this.dlg;
    window.setTimeout(function () { try { focusTarget.focus(); } catch (e) {} }, 30);
  };

  WinnerModal.prototype.close = function () {
    this.stop();
    document.body.classList.remove('sj-w-modal-open');
    if (this.dlg.open && typeof this.dlg.close === 'function') this.dlg.close();
    else this.dlg.removeAttribute('open');
    if (this.opener) { try { this.opener.focus(); } catch (e) {} }
  };

  WinnerModal.prototype.step = function (dir) {
    var vis = this.visibleIndexes();
    if (!vis.length) return;
    var at = vis.indexOf(this.index);
    var next = at === -1 ? 0 : at + dir;
    if (next < 0 || next >= vis.length) return;
    this.stop();
    this.index = vis[next];
    this.render();
  };

  WinnerModal.prototype.updateNav = function () {
    var vis = this.visibleIndexes();
    var at = vis.indexOf(this.index);
    if (this.prevBtn) this.prevBtn.disabled = at <= 0;
    if (this.nextBtn) this.nextBtn.disabled = at === -1 || at >= vis.length - 1;
    if (this.counterEl) this.counterEl.textContent = at > -1 ? (String(at + 1) + ' / ' + String(vis.length)) : '';
  };

  WinnerModal.prototype.stop = function () {
    if (!this.frame) return;
    var v = this.frame.querySelector('video');
    if (v) { try { v.pause(); } catch (e) {} }
    var f = this.frame.querySelector('iframe');
    if (f) f.remove();
  };

  WinnerModal.prototype.render = function () {
    var w = this.data[this.index];
    if (!w) return;
    var s = this.strings;
    if (this.nameEl) this.nameEl.textContent = w.name || '';
    if (this.prizeEl) { this.prizeEl.textContent = w.prize || ''; this.prizeEl.hidden = !w.prize; }

    if (this.dlEl) {
      var rows = [];
      if (w.location) rows.push([s.location || 'Location', w.location]);
      if (w.drawnText) rows.push([s.drawingDate || 'Drawing date', w.drawnText]);
      if (w.announcedText) rows.push([s.announcedDate || 'Announced', w.announcedText]);
      if (w.category) rows.push([s.category || 'Prize type', w.category]);
      if (w.prizeDesc) rows.push([s.prizeDetails || 'Prize', w.prizeDesc]);
      if (w.prizeSpecs) rows.push([s.specs || 'Specs', w.prizeSpecs]);
      this.dlEl.innerHTML = rows.map(function (r) { return '<dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd>'; }).join('');
      this.dlEl.hidden = rows.length === 0;
    }
    if (this.storyEl) { this.storyEl.textContent = w.story || ''; this.storyEl.hidden = !w.story; }

    if (this.linksEl) {
      /* Only the winner's own Instagram post link is offered here. The
         Official Rules stay in the site footer and legal navigation. */
      var links = [];
      var showPost = w.socialShow !== false;
      if (w.social && showPost) {
        links.push(
          '<a class="sj-w__btn sj-w__btn--blue" href="' + esc(w.social) + '" target="_blank" rel="noopener noreferrer">' +
          esc(w.socialLabel || s.social || 'View the post') +
          '<span class="sj-w__sr"> (opens Instagram in a new tab)</span></a>'
        );
      }
      this.linksEl.innerHTML = links.join('');
      this.linksEl.hidden = links.length === 0;
    }

    /* thumbnails */
    if (this.thumbs) {
      var media = w.media || [];
      if (media.length > 1) {
        var t = [];
        media.forEach(function (m, i) {
          var src = m.type === 'image' ? m.src : (m.poster || '');
          t.push('<button type="button" data-sj-thumb="' + i + '" aria-current="' + (i === 0 ? 'true' : 'false') + '" aria-label="' + esc((s.media || 'Media') + ' ' + (i + 1)) + '">' +
            (src ? '<img src="' + esc(src) + '" alt="" loading="lazy" decoding="async" width="156" height="112">' : '') +
            (m.type === 'video' ? '<svg class="sj-w-modal__thumbvid" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>' : '') +
            '</button>');
        });
        this.thumbs.innerHTML = t.join('');
        this.thumbs.hidden = false;
      } else {
        this.thumbs.innerHTML = '';
        this.thumbs.hidden = true;
      }
    }

    this.showMedia(0, false);
    this.updateNav();
  };

  WinnerModal.prototype.showMedia = function (i, focusFrame) {
    var w = this.data[this.index];
    if (!w || !this.frame) return;
    var media = w.media || [];
    this.stop();
    this.mediaIndex = Math.max(0, Math.min(i, media.length - 1));
    var m = media[this.mediaIndex];
    var s = this.strings;
    this.frame.setAttribute('data-kind', m && m.type === 'video' ? 'video' : 'image');

    if (this.thumbs) {
      var btns = this.thumbs.querySelectorAll('[data-sj-thumb]');
      Array.prototype.forEach.call(btns, function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }

    if (!m) {
      this.frame.innerHTML = '<div class="sj-w-card__noimg" aria-hidden="true">' + ICON_TROPHY + '</div>';
      return;
    }

    if (m.type === 'image') {
      this.frame.innerHTML = '<img src="' + esc(m.src) + '" alt="' + esc(m.alt || (w.name + ' - ' + w.prize)) + '" width="' + esc(m.w || 1600) + '" height="' + esc(m.h || 900) + '" decoding="async">';
      return;
    }

    /* video: render poster + explicit play button. Nothing loads until asked. */
    var poster = m.poster || '';
    var label = esc((s.watch || 'Play the winning moment') + (w.name ? ' - ' + w.name : ''));
    this.frame.innerHTML =
      '<button type="button" class="sj-w-modal__poster" data-sj-playbtn aria-label="' + label + '">' +
      (poster ? '<img src="' + esc(poster) + '" alt="" loading="lazy" decoding="async" width="1600" height="900">' : '') +
      '<span><i>' + ICON_PLAY + '</i></span></button>';
    if (focusFrame) { var b = this.frame.querySelector('[data-sj-playbtn]'); if (b) b.focus(); }
  };

  WinnerModal.prototype.play = function () {
    var w = this.data[this.index];
    if (!w || !this.frame) return;
    var m = (w.media || [])[this.mediaIndex];
    if (!m || m.type !== 'video') return;
    var title = esc((this.strings.watch || 'Winning moment') + (w.name ? ' - ' + w.name : ''));
    var html;
    if (m.kind === 'youtube') {
      html = '<iframe src="https://www.youtube-nocookie.com/embed/' + esc(m.src) + '?autoplay=1&rel=0&playsinline=1" title="' + title + '" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen" allowfullscreen loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>';
    } else if (m.kind === 'vimeo') {
      html = '<iframe src="https://player.vimeo.com/video/' + esc(m.src) + '?autoplay=1&dnt=1&playsinline=1" title="' + title + '" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>';
    } else if (m.kind === 'shopify' && Array.isArray(m.sources)) {
      html = '<video controls playsinline preload="metadata"' + (m.poster ? ' poster="' + esc(m.poster) + '"' : '') + '>' +
        m.sources.map(function (src) { return '<source src="' + esc(src.url) + '" type="' + esc(src.mime) + '">'; }).join('') +
        '</video>';
    } else {
      html = '<video controls playsinline preload="metadata"' + (m.poster ? ' poster="' + esc(m.poster) + '"' : '') + ' src="' + esc(m.src) + '"></video>';
    }
    this.frame.innerHTML = html;
    var v = this.frame.querySelector('video');
    if (v) { v.muted = false; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  };

  /* =================== Featured section hand-off + boot =================== */
  function initFeatured(el) {
    if (el.dataset.sjReady === '1') return;
    el.dataset.sjReady = '1';
    el.addEventListener('click', function (ev) {
      var t = ev.target.closest('[data-sj-featured-open]');
      if (!t) return;
      var id = t.getAttribute('data-sj-featured-open');
      var mi = t.getAttribute('data-sj-media-index');
      var target = document.querySelector(ROOT_SEL);
      if (!target) return;
      ev.preventDefault();
      target.dispatchEvent(new CustomEvent('sj:open-winner', { detail: { id: id, mediaIndex: mi, trigger: t } }));
    });
  }

  function boot(scope) {
    var r = scope || document;
    Array.prototype.forEach.call(r.querySelectorAll(ROOT_SEL), initGallery);
    Array.prototype.forEach.call(r.querySelectorAll('[data-sj-featured]'), initFeatured);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);

  /* Theme editor / section rendering API re-renders */
  document.addEventListener('shopify:section:load', function (ev) { boot(ev.target); });
  document.addEventListener('shopify:section:unload', function (ev) {
    var d = ev.target.querySelector('[data-sj-modal]');
    if (d && d.open) { try { d.close(); } catch (e) {} document.body.classList.remove('sj-w-modal-open'); }
  });

  window.SJWinners = { boot: boot, reduceMotion: reduceMotion };
})();
